import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useQuestionSidebarStyles = makeStyles(() => ({
  rootPaper: {
    display: "flex",
    flexDirection: "column",
    // padding: theme.spacing(2),
    backgroundColor: "#E3F2FD",
    overflow: "hidden",
  },
  rootHeightHaf: {
    height: "calc(100vh - 44px)",
  },
  rootHeightFull: {
    height: "calc(100vh - 0px)",
  },
  topSection: {
    backgroundColor: "#E3F2FD",
    flex: "0 0 auto",
    position: "sticky",
    // height:'200px'
    // marginBottom: theme.spacing(2),
  },
  timeText: {
    fontWeight: "bold",
  },
  statusLegendGrid: {
    background: "white",
    padding: "10px",
    // marginTop: theme.spacing(2),
  },
  statusItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  questionsPalette: {
    overflow: "auto",
    height: "calc(100vh - 40px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "#E3F2FD",
    // paddingBottom:''
    "&::-webkit-scrollbar": {
      width: "0px",
    },
  },
  paletteHeader: {
    backgroundColor: "#1976D2",
    color: "white",
    padding: theme.spacing(1),
    borderRadius: "4px 4px 0 0",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  chooseQuestionText: {
    fontWeight: "bold",
    padding: "10px",
    paddingBottom: "0px",
    backgroundColor: "#E3F2FD",
  },
  questionGrid: {
    // maxHeight:'calc(100vh - 415px)',
    padding: "10px",
    backgroundColor: "#E3F2FD",
  },
  questionItem: {
    cursor: "pointer",
  },
  profileImagecontainer: {
    width: "30%",
    margin: "0 auto",
    display: "flex",
    background: "#E0E0E2",
    borderRadius: "10px",
    flexShrink: "0",
    margin: "0px",
    marginRight: "20px",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  profileImagewidth: {
    width: "40%",
  },
  profileImage: {
    maxWidth: "100%",
    aspectRatio: "1 / 1",
    borderRadius: "10px",
    flexShrink: "0",
    margin: "auto",
  },
}));

export default useQuestionSidebarStyles;
